<template>
    <div class="div-header" style="background-color: #FFFFFF;">
        <div
            style="margin: 0;line-height: 68px;display: flex;width: 1200px;background-color: #FFFFFF;position:relative;left: 30px;"
            :style="{marginLeft: headerMarginLeft+'px'}">
            <div style="width: 125px;">
                <img src="../../assets/images/heng_dian.png" alt=""
                     style="width:125px;height: 25px;position: relative;top: 6px;">
            </div>
            <div style="flex:1;text-align: center;">
                <a :href="'http://www.'+MainUrl+'/'">首页</a>
                <a :href="'http://www.'+MainUrl+'/lab-center/index.html'">在线实验室</a>
                <a :href="'http://www.'+MainUrl+'/course/index.html'">课程中心</a>
                <a :href="'http://www.'+MainUrl+'/vrzone/index.html'">VR智慧教室</a>
                <a :href="'http://www.'+MainUrl+'/micro/index.html'">微专业</a>
                <a :href="'http://www.'+MainUrl+'/living/index.html'">直播</a>
                <a :href="'http://www.'+MainUrl+'/helper/index.html'">帮助中心</a>
                <a :href="'http://knowledge.'+MainUrl+'/'">学 · 问</a>
            </div>
            <div style="width: 200px;">
                <img :src="avatar" alt=""
                     class="headerImg" v-if="isLogin">
                <el-dropdown trigger="click" @command="jump" v-if="isLogin"
                             style="line-height: 25px;padding-left: 0.5em;">
                    <span class="el-dropdown-link spanLink">{{ username }}<i
                        class="el-icon-arrow-down el-icon--right"></i></span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="goUserCenter">个人中心</el-dropdown-item>
                        <el-dropdown-item command="/bind-and-password">账号管理</el-dropdown-item>
                        <el-dropdown-item @click.native="logout">安全退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <span class="el-dropdown-link spanLink" @click="jump('/')"
                      v-if="!isLogin">
                     登录/注册
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Header',
    created () {
        this.MainUrl = localStorage.getItem('MainUrl')
        let uncheckPath = [
            '/get-back-password',
            '/set-new-password'
        ]
        if (uncheckPath.indexOf(this.$route.path) === -1) {
            if (this.isEmpty(localStorage.getItem('jwt'))) {
                //跳转至首页
                console.log('跳转至首页3')
                this.$router.push({
                    path: '/'
                })
                return
            }
        }
        this.getUserInfo()
    },
    mounted () {
        let that = this
        this.$nextTick(function () {
            this.setHeaderLeft()
            window.addEventListener('storage', (e) => {
                switch (e.key) {
                    case 'avatar':
                        if (that.avatar !== e.newValue) {
                            that.avatar = e.newValue
                        }
                        break
                    case 'jwt':
                        if (e.newValue === 'null' || e.newValue === null) {
                            //跳转至首页
                            that.$router.push('/')
                        }
                        break
                }
            })
            window.addEventListener('setItemEvent', (e) => {
                if (e.key === 'avatar') {
                    if (that.avatar !== e.newValue) {
                        that.avatar = e.newValue
                    }
                }
                if (e.key === 'WindowsOnResize') {
                    //刷新页面
                    that.setHeaderLeft()
                }
            })
        })
    },
    data: function () {
        return {
            headerMarginLeft: 0,
            isLogin: false,
            uid: 0,
            avatar: '',
            username: '',
            is_teacher: 0,
            MainUrl: ''
        }
    },
    methods: {
        setHeaderLeft () {
            console.log('setHeaderLeft')
            this.headerMarginLeft = (document.body.offsetWidth - 1250) / 2
        },
        jump (url) {
            console.log('header-jump-url:', url)
            this.$router.push({
                path: url
            })
        },
        getUserInfo () {
            if (!this.isEmpty(localStorage.getItem('jwt'))) {
                this.isLogin = true
                let that = this
                if (!this.isEmpty(localStorage.getItem('avatar'))) {
                    that.avatar = localStorage.getItem('avatar')
                    if (localStorage.getItem('username')) {
                        that.username = localStorage.getItem('username')
                    }
                } else {
                    this.$ajax.get('/api/user/get').then(function (r) {
                        that.uid = r.data.id
                        localStorage.setItem('username', r.data.username)
                        that.username = r.data.username
                        localStorage.setItem('avatar', r.data.avatar)
                        that.avatar = r.data.avatar
                        that.is_teacher = r.data.is_teacher
                    })
                }
            }
        },
        refreshAvatar () {
            if (this.avatar !== localStorage.getItem('avatar')) {
                this.avatar = localStorage.getItem('avatar')
            }
            let that = this
            setTimeout(function () {
                that.refreshAvatar()
            }, 2000)
        },
        logout () {
            let that = this
            this.$ajax.get('/api/user/logout').then(function (r) {
                //清除cookie
                that.cookieRemoveAll()
                that.$router.push({
                    path: '/'
                })
            })
        },
        goUserCenter () {
            //跳转用户中心
            let domain = 'http://www.' + this.MainUrl
            let url = domain + '/student.html'
            if (this.is_teacher) {
                url = domain + '/teacher.html'
            }
            url += '?jwt=' + localStorage.getItem('jwt')
            window.location.href = url
        }
    }
}
</script>

<style scoped="scoped">
.div-header {
    background-color: #FFFFFF;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    box-shadow: 5px 5px 5px #EEEEEE;
    height: 68px;
    text-align: center;
}

a {
    color: #000000;
    text-decoration: none;
    margin-left: 0.5em;
    margin-right: 0.5em;
}

a:hover {
    color: #00a4e0;
}

.headerImg {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    position: relative;
    top: 15px;
    box-shadow: 0 0 12px 1px #CCCCCC;
}

.spanLink {
    cursor: pointer;
    color: #01bafd;
    font-size: 14px;
}

[v-cloak] {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/public/Header.vue